<script>
import Lazyload     from "@core/assets/js/modules/lazyload";
import bodyRefresh  from "@core/assets/js/modules/body.refresh";

export default {
  name: "_Page.vue",
  beforeMount() {
    if (window._page)
      this.$store.commit('section/page', window._page)
  },
  mounted() {
    bodyRefresh.setup();
    window.addEventListener('load', () => Lazyload.start())
  },
  computed: {
    page: function () { return this.$store.getters["section/page"] }
  },
}
</script>